import { render, staticRenderFns } from "./EditarPuertaModal.vue?vue&type=template&id=60a81632"
import script from "./EditarPuertaModal.vue?vue&type=script&lang=js"
export * from "./EditarPuertaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports